import * as React from 'react'

import { palette } from 'main/ui'
import { SVGResponsive } from './common'

function CreditCard() {
  return (
    <SVGResponsive height={30} width={40}>
      <rect width="40" height="30" rx="2" fill={palette.chrome} />
      <rect y="7" width="40" height="7" fill={palette.mediumGray} />
    </SVGResponsive>
  )
}

export default React.memo(CreditCard)
